import gql from 'graphql-tag';

export default gql`
    mutation UpdatePumpScheduleInfo($input: PumpScheduleEdit) {
        updatePumpScheduleInfo(input: $input) {
            errors
        }
    }
`;
